import React from 'react';

function Hero({ scrollToSection }) {
  const whatsappNumber = '971XXXXXXXXX'; // CHANGE THIS to your WhatsApp number

  return (
    <section id="home" className="hero-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-8">
            <h1 className="hero-title">
              Safe. Reliable. Comfortable Transport Across the UAE.
            </h1>
            <p className="hero-subtitle">
              Modern Fleet • RTA-Approved Drivers • 24/7 Service
            </p>
            <p className="hero-text">
              Professional passenger transport for corporate clients, schools, hotels, 
              tourism operators, and private groups across all seven Emirates.
            </p>
            <div className="hero-buttons">
              <button 
                className="btn btn-gold" 
                onClick={() => window.open(`https://wa.me/${whatsappNumber}?text=Hello, I want to book a bus from BARQ ALWUSOOL`, '_blank')}
              >
                Book Now
              </button>
              <button 
                className="btn btn-outline"
                onClick={() => window.open(`https://wa.me/${whatsappNumber}?text=Hello, I need information about your services`, '_blank')}
              >
                WhatsApp Us
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;